import React from 'react';
import { DateRangePickerCompat as DateRangePickerCompatNew } from './DateRangePickerCompat';
import { convertOldDateRangePickerProps, OldDateRangePickerProps } from './converter.old';

export type DateRangePickerProps = OldDateRangePickerProps;
export type DateRangePickerCompatProps = DateRangePickerProps;
export const DateRangePickerCompat: React.FC<DateRangePickerProps> = (props) => (
  <DateRangePickerCompatNew {...convertOldDateRangePickerProps(props)} />
);
export const DateRangePicker = DateRangePickerCompat;
